import React from 'react';

const ButtonMDX = ({ text, action }) => <button onClick={action}>{text}</button>;

export default ButtonMDX;
